export default __webpack_public_path__ + "static/Lisboa2020_RGB_1a-08285f523ce1404cef1215730f7ac185.png";